export const Heading = {
  baseStyle: {
    lineHeight: 1.43,
    fontFamily: 'heading',
  },
};
